import { render } from "./ProgressModal.vue?vue&type=template&id=767c8829"
import script from "./ProgressModal.vue?vue&type=script&lang=js"
export * from "./ProgressModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QLinearProgress,QCardSection,QBadge});
